/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import * as action from '../store/DevelopmentOrder.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import './DesignDetail.css';
import { useTranslation } from 'react-i18next';

function ImportFileModal({ onOpen, toggle, onSubmit }) {
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const reducerData = useSelector((redState) => redState);
  const { Measuremets } = reducerData;
  const { documentOptionList } = Measuremets;
  const { t } = useTranslation('common');
  const [showLoader, setShowLoader] = useState(false);
  const [document, setDocument] = useState(false);
  const [manualDocs, setManualDocs] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [parentsFolderList, setParentsFolderList] = useState('');

  const [parnetItem, setParnetItem] = useState(null);
  const mainElse = async (item) => {
    if (manualDocs) {
      const params = {
        parent: item?._id,
      };
      setShowLoader(true);
      const response = await dispatch(action.getManualAndDocs(params));
      if (response) setShowLoader(false);
    } else {
      item.parent === null && setParnetItem(item);
      const params = {
        devOrderId: item?.devOrderId,
        isDefault: item?.isDefault,
        name: item?.name,
        parent: item?.parent === null ? item?._id : parnetItem?._id,
      };
      if (item.bomType) {
        params.bomType = item.bomType;
      }
      setShowLoader(true);
      const response = await dispatch(action.getAllDocumentList(params));
      if (response) setShowLoader(false);
    }
  };

  const foldersApis = async (item) => {
    if (item?._id === 'Documents') {
      setShowLoader(true);
      setDocument(true);
      manualDocs && setManualDocs(false);
      const res = await dispatch(action.getAllDocumentList({ devOrderId }));
      if (res) setShowLoader(false);
    } else if (item?._id === 'Manuals And Documents') {
      setShowLoader(true);
      setManualDocs(true);
      document && setDocument(false);
      const response = await dispatch(action.getManualAndDocs());
      if (response) setShowLoader(false);
    } else {
      mainElse(item);
    }
  };

  const backBtn = async () => {
    parentsFolderList?.pop();
    setSelectedFile(null);
    setParnetItem(null);
    if (showErr) setShowErr(false);
    isEmpty(parentsFolderList) ? dispatch(action.resetModal()) : foldersApis(parentsFolderList[parentsFolderList.length - 1]);
  };

  const selectedListItem = async (item) => {
    if (item?.pdfTitle ? item?.pdfTitle && item?.type === 'Folder' : item?.name && item?.type === 'Folder') {
      setParentsFolderList([...parentsFolderList, item]);
      if (showErr) setShowErr(false);
      foldersApis(item);
    } else if (item.type === 'image/png' || item.type === 'image/jpeg') {
      setSelectedFile(item);
      if (showErr) setShowErr(false);
    } else {
      setShowErr(true);
      setSelectedFile(item);
    }
  };

  const goHome = async () => {
    setParnetItem(null);
    setParentsFolderList([]);
    if (showErr) setShowErr(false);
    await dispatch(action.resetModal());
  };

  const folderClass = (ele) => {
    return ele?.type !== 'Folder' && selectedFile?._id === ele?._id
      ? 'align-items-center d-flex justify-content Document-active'
      : 'align-items-center d-flex justify-content';
  };
  const docIcons = (ele) => {
    return ele.type === 'Folder' ? <span className="upicon-folder icon-colour" /> : <span className="upicon-home icon-colour" />;
  };
  const iconType = (ele) => {
    return parnetItem?.type === 'Folder' && parnetItem?.name === 'DESIGN' ? <span className="upicon-doc icon-colour" /> : docIcons(ele);
  };

  const nameList = (valName) => {
    switch (valName) {
      case 'BOM':
        return t('TAKING_DATES.BOM_SUPPORTING_DOCUMENTS');
      case 'SPECIFIC_SUPPORTING':
        return t('TAKING_DATES.SPECIFICATION_SUPPORTING_DOCUMENT');
      case 'TEST':
        return t('TAKING_DATES.TEST_REPORTS');
      case 'CARE_LAYOUT':
        return t('TAKING_DATES.CARE_LABEL_LAYOUTS');
      case 'COLOUR':
        return t('TAKING_DATES.COLOR_SUPPORTING_DOCUMENTS');
      case 'PO_DOCUMENTS':
        return t('TAKING_DATES.P.O_DOCUMENT');
      case 'DESIGN':
        return t('TAKING_DATES.DESIGN_DETAIL');
      default:
        return valName;
    }
  };

  const mainBody = () => {
    return !isEmpty(documentOptionList) && !showLoader ? (
      documentOptionList.map((ele) => {
        return (
          <ul key={ele?._id} className="ImportFileLi">
            <div className={folderClass(ele)}>
              <button type="button" onClick={ele?.type !== 'Folder' ? goHome : null} className="btn">
                {ele?.name === 'Documents' || ele?.name === 'Manuals And Documents' ? <span className="upicon-home icon-colour" /> : iconType(ele)}
              </button>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
              <li onClick={() => selectedListItem(ele)}>{nameList(ele?.pdfTitle ? ele?.pdfTitle : ele?.name)}</li>
              <button
                type="button"
                aria-label="back"
                className="btn ml-auto forwardBtn"
                style={{ transform: 'rotate(180deg)' }}
                onClick={() => selectedListItem(ele)}
              >
                <i className="icon-back" />
              </button>
            </div>
          </ul>
        );
      })
    ) : (
      <span>{t('TAKING_DATES.NO_FOLDER_FOUND')}</span>
    );
  };

  const selectFile = async () => {
    onSubmit(selectedFile);
  };

  const close = async () => {
    toggle();
  };

  return (
    <Modal show={onOpen} className="custom-modal modal-small color-way-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header className="d-flex justify-content-end align-items-center">
        {!isEmpty(parentsFolderList) && (
          <button type="button" aria-label="back" onClick={backBtn} className="btn">
            <span className="icon-back" style={{ rotate: '180' }} />
          </button>
        )}
        <span className="mr-auto">
          {parentsFolderList[parentsFolderList.length - 1]?.pdfTitle
            ? parentsFolderList[parentsFolderList.length - 1]?.pdfTitle
            : parentsFolderList[parentsFolderList.length - 1]?.name}
        </span>
        <button type="button" aria-label="close" name="close" onClick={close} className="btn">
          <span className="icon-close cursor-pointer" />
        </button>
      </Modal.Header>
      <Modal.Body>
        {showLoader ? <Loader /> : mainBody()}
        {!isEmpty(documentOptionList) && (
          <button name="close" onClick={selectFile} className="btn btn-default ml-2" type="button" disabled={showErr}>
            {t('TAKING_DATES.SELECTS')}
          </button>
        )}
        {showErr && <span className="error-message">{t('TAKING_DATES.SELECT_IMAGE_FILE')}</span>}
      </Modal.Body>
    </Modal>
  );
}

export default ImportFileModal;
